module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "23%"
    },
    attrs: {
      "label": "活动时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": function($event) {
        return _vm.changetime(1)
      }
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "23%"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.csOptions,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChangesscs
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.findinfo()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("店铺红包")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showadd()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.envelopeList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.begindate) + " - " + _vm._s(scope.row.enddate))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属城市",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.area))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "红包总金额（元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.totalprice))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "红包数量（个）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.totalcount))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已发放数量(个)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('b', {
          staticStyle: {
            "color": "#409EFF"
          },
          on: {
            "click": function($event) {
              return _vm.handleSeeLlmx(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.usedcount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已发放金额(元)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.usedprice))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "退款金额(元)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.refundprice))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\r\n            " + _vm._s(scope.row.status == 1 ? '草稿' : scope.row.status == 5 ? '待开始' : scope.row.status == 10 ? '进行中' : scope.row.status == 20 ? '已结束' : '已关闭') + "\r\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 1),
            expression: "scope.row.status==1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleUpper(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        }), _vm._v(" 开启 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 5),
            expression: "scope.row.status==5"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleUpper(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-close"
        }), _vm._v(" 关闭 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 10),
            expression: "scope.row.status==10"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleUpper(scope.row, 4)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-remove-outline"
        }), _vm._v(" 结束 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 1),
            expression: "scope.row.status==1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showadd(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 1),
            expression: "scope.row.status!=1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showadd(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 1),
            expression: "scope.row.status==1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleUpper(scope.row, 3)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "红包领取明细",
      "custom-class": "registrationRecord",
      "visible": _vm.visibleLqmx,
      "size": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visibleLqmx = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.lqmxList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "phone",
      "label": "用户",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "price",
      "label": "金额（元）",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "receivetime",
      "label": "领取时间",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexLqmx,
      "page-size": 10,
      "total": _vm.totalLqmx
    },
    on: {
      "current-change": _vm.handleLqmx
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "红包配置",
      "visible": _vm.dialogVisibleshenhe,
      "before-close": _vm.handleClose,
      "center": "",
      "width": "45%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleshenhe = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "50%"
    },
    attrs: {
      "label": "活动时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptionsStart,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "disabled": _vm.disabledHB
    },
    on: {
      "change": function($event) {
        return _vm.changetime(2)
      }
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "红包配置："
    }
  }, [_vm._l((_vm.formItems), function(item, index) {
    return _c('el-form-item', {
      key: index
    }, [_c('el-row', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "gutter": 16
      }
    }, [_c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "price"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "单个金额",
        "maxlength": "6",
        "clearable": "",
        "disabled": _vm.disabledHB,
        "onkeyup": "value=value.replace(/[^\\d]/g,'');"
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    }, [_c('i', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "slot": "suffix"
      },
      slot: "suffix"
    }, [_vm._v("元")])])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_vm._v("✖")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "count"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "红包数量",
        "maxlength": "6",
        "clearable": "",
        "disabled": _vm.disabledHB,
        "onkeyup": "value=value.replace(/[^\\d]/g,'');"
      },
      model: {
        value: (item.count),
        callback: function($$v) {
          _vm.$set(item, "count", $$v)
        },
        expression: "item.count"
      }
    }, [_c('i', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "slot": "suffix"
      },
      slot: "suffix"
    }, [_vm._v("个")])])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "greeting"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "红包贺词最多10个字",
        "maxlength": "10",
        "clearable": "",
        "disabled": _vm.disabledHB
      },
      model: {
        value: (item.greeting),
        callback: function($$v) {
          _vm.$set(item, "greeting", $$v)
        },
        expression: "item.greeting"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.disabledHB && index > 0),
        expression: "!disabledHB && index > 0"
      }],
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabledHB),
      expression: "!disabledHB"
    }],
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加配置")])], 2), _vm._v(" "), _c('p', [_vm._v("红包总额："), _c('b', [_vm._v(_vm._s(_vm.RIntention) + " 元")])])], 1), _vm._v(" "), _c('ul', {
    staticStyle: {
      "line-height": "26px",
      "color": "#F56C6C"
    }
  }, [_c('li', [_vm._v("重要提示：")]), _vm._v(" "), _c('li', [_vm._v("1.单个红包金额不低于6.66元;")]), _vm._v(" "), _c('li', [_vm._v("2.可配置多组红包，进行随机配置;")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisibleshenhe = false
      }
    }
  }, [_vm._v(_vm._s(_vm.disabledHB ? "关闭" : "取消"))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabledHB),
      expression: "!disabledHB"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.adopt()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认提示",
      "visible": _vm.fufeidialog,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.fufeidialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "10px 0 20px 0",
      "font-size": "16px"
    }
  }, [_vm._v("确定要支付红包费用后开启新人红包活动吗？")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("-" + _vm._s(_vm.zysj) + " 元")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.fufeidialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.qdfufeu()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请使用微信扫码支付",
      "visible": _vm.wxsmzfVisible,
      "width": "20%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.wxsmzfVisible = $event
      },
      "close": function($event) {
        return _vm.closeWxsmzf()
      }
    }
  }, [_c('div', {
    staticClass: "wxsmzfClass"
  }, [_c('P', [_vm._v(_vm._s(_vm.wxsmzfJine) + " 元")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.wxSmzfImg
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择活动城区",
      "visible": _vm.visibleSynchdcq,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visibleSynchdcq = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "活动城区："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.csOptions,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChangesscs
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3236f375!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/platformManagement/areaRedpacketActivity.vue
// module id = 1666
// module chunks = 3